import {Injectable} from "@angular/core";
import {Logentry} from "./logentry.model";
import {Queue} from "./queue.model";
import {LogConfigService} from "./logconfig.service";

/*
 * @whatItDoes: Stores Logs in a Queue s.t. logs can be bundled and send together
 */
@Injectable()
export class BufferLoggerService {

  private logQueue: Queue<Logentry>;

  constructor(public config: LogConfigService) {
    this.logQueue = new Queue<Logentry>(config.onExceptionLogBulkSize);
  }

  public log(entry: Logentry) {
    this.logQueue.add(entry);
  }

  public popAll(): Array<Logentry> {
    return this.logQueue.popAll();
  }

}
